export default "__VITE_ASSET__BNPG47d6__"